import { render, staticRenderFns } from "./BetgameDelete.vue?vue&type=template&id=1ec00c3b&scoped=true"
import script from "./BetgameDelete.vue?vue&type=script&lang=js"
export * from "./BetgameDelete.vue?vue&type=script&lang=js"
import style0 from "./BetgameDelete.vue?vue&type=style&index=0&id=1ec00c3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec00c3b",
  null
  
)

export default component.exports